import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccionesDialog, RangoFechasValores, TiposLiquidacion } from '@models/base/identificadores.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TipoAjusteContratoDto } from '@models/tipo-ajuste-contrato/tipoAjusteContratoDto.model';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TipoAjusteContratoService } from '@services/tipo-ajuste-contrato/tipoAjusteContrato.service';
import { isFalsy } from 'utility-types';
import { DatePipe } from '@angular/common';
import { PeriodoContratoDetailDto } from '@models/periodos-contrato/periodoContratoDetailDto.model';
import { Genericos } from '@models/base/genericos.model';
import { PeriodosContratoService } from '@services/periodos-contrato/periodos-contrato.service';
import { PeriodoContratoFilter } from '@models/periodos-contrato/periodoContratoFilter.model';
import { DialogVerPeriodoContratoDetailDtoComponent } from '../dialog-ver-periodo-contrato-detail-dto/dialog-ver-periodo-contrato-detail-dto.component';
import { BaseDto } from '@models/base/baseDto.model';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import { DialogEditarPeriodosContratoComponent } from '@views/contratos/dialog-nuevo-recibo/dialog-editar-periodos-contrato/dialog-editar-periodos-contrato.component';
import { DialogUpdatePeriodoContratoComponent } from '../dialog-update-periodo-contrato/dialog-update-periodo-contrato.component';
import { DialogAyudaTotalesComponent } from '../dialog-ayuda-totales/dialog-ayuda-totales.component';
import { EstadosContratoService } from '@services/estados-contratos/estados-contrato.service';
import { PersonaPropietarioDto } from '@models/propietarios/personaPropietarioDto.model';

const moment = _rollupMoment || _moment;

// Interfaz para el filtro persistente
interface PeriodoContratoFilterState {
  tiposAjusteContrato?: number[];
  fechaAjusteDesde?: string;
  fechaAjusteHasta?: string;
  fechaVencimientoDesde?: string;
  fechaVencimientoHasta?: string;
  fechaLiquidacionDesde?: string;
  fechaLiquidacionHasta?: string;
  fechaPagoDesde?: string;
  fechaPagoHasta?: string;
  periodoMesDesde?: number;
  periodoAnioDesde?: number;
  periodoMesHasta?: number;
  periodoAnioHasta?: number;
  esContratoActivo?: boolean;
  contratoDetailDto?: BaseDto | null;
  rangoFechaAjuste?: number;
  rangoFechaVencimiento?: number;
  rangoFechaLiquidacion?: number;
  rangoFechaPago?: number;
  estadosContrato?: number[];
  propietariosSeleccionados?: PersonaPropietarioDto[];
}

export const DATE_FORMATS = {
  default: {
    parse: {
      dateInput: 'DD/MM/YYYY',
    },
    display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'MMM YYYY',
      monthYearAriaLabel: 'MMM YYYY',
      yearLabel: 'YYYY',
      yearAriaLabel: 'YYYY',
    },
  },
  monthYear: {
    parse: {
      dateInput: 'MM/YYYY',
    },
    display: {
      dateInput: 'MM/YYYY',
      monthYearLabel: 'MMM YYYY',
      monthYearAriaLabel: 'MMM YYYY',
      yearLabel: 'YYYY',
      yearAriaLabel: 'YYYY',
    },
  },
};

@Component({
  selector: 'app-periodo-contrato',
  templateUrl: './periodo-contrato.component.html',
  styleUrls: ['./periodo-contrato.component.css'],
  providers: [DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS.default },
  ],
})
export class PeriodoContratoComponent implements OnInit {

  private readonly FILTER_STORAGE_KEY = 'periodo-contrato-filter';
  @ViewChild('buscarPropietarioRef') buscarPropietarioRef: any;

  dataSource = new MatTableDataSource<PeriodoContratoDetailDto>();
  obj!: undefined
  displayedColumns: string[] = [];
  data = false
  lstRangoFecha = Genericos.lstRangoFecha
  form: FormGroup;
  formBuilder = new FormBuilder
  rangoFechaAjuste: number = RangoFechasValores.Hoy
  rangoFechaVencimiento: number = RangoFechasValores.Hoy
  rangoFechaLiquidacion: number = RangoFechasValores.Hoy
  rangoFechaPago: number = RangoFechasValores.Hoy
  @ViewChild(MatTable, { static: true }) table!: MatTable<PeriodoContratoDetailDto>;

  private paginator!: MatPaginator;
  private sort!: MatSort;
  lstTiposAjusteContrato!: TipoAjusteContratoDto[];
  contrato: any;
  contratoDetailDto: BaseDto | null = null;
  lstPeriodosContrato!: PeriodoContratoDetailDto[];

  //#region Totales ORIGINALES — los calcula calcularTotalesCobranza()
  // Son los que ya existían. Ninguno cambió de valor ni de definición.

  /** Σ importe de los períodos ya vencidos (Fecha Vencimiento <= hoy) */
  totalDevengado: number = 0
  /** Σ importe de los períodos con Fecha Pago */
  totalPagado: number = 0
  /** Σ importe de los períodos sin Fecha Pago, incluidos los que aún no vencieron */
  totalACobrar: number = 0
  /** Σ importe de los períodos sin Fecha Pago Y ya vencidos. Es la mora real. */
  deudaInquilino: number = 0
  /** Cantidad de períodos vencidos e impagos */
  cantidadPeriodosEnMora: number = 0
  /** Σ importe liquidado al propietario que todavía no se le cobró al inquilino */
  liquidadoSinCobrar: number = 0
  /**
   * Σ importe de lo que HOY se le puede rendir al propietario y todavía no se
   * rindió.
   *
   * El criterio depende del tipo de liquidación del contrato, igual que en el
   * back (PropietarioRepository):
   *
   *   - REAL: sólo los períodos con fecha de pago. No se le puede rendir al
   *     propietario plata que el inquilino no puso.
   *   - FICTICIA: los períodos ya vencidos, se hayan cobrado o no. Acá la
   *     inmobiliaria adelanta y le rinde igual.
   *
   * Antes sumaba todos los períodos sin fecha de liquidación sin mirar el tipo
   * ni el vencimiento: contaba como "por liquidar" alquileres de meses que ni
   * se habían devengado.
   */
  totalPorLiquidar: number = 0

  /**
   * Σ importe vencido, sin cobrar y sin liquidar, SÓLO de contratos con
   * liquidación real.
   *
   * Es lo que hay que cobrar antes de poder rendirlo. En los contratos de
   * liquidación ficticia esto no existe como concepto: ya entra en "por
   * liquidar".
   */
  devengadoSinCobrarNiLiquidar: number = 0

  /** Para avisar en pantalla cuando el filtro mezcla contratos de los dos tipos */
  hayLiquidacionReal: boolean = false
  hayLiquidacionFicticia: boolean = false
  //#endregion

  //#region Cierre de la liquidación — los calcula calcularTotalesLiquidacion()
  // Agregados después, para que la tarjeta del propietario cierre sola.

  /** Σ importe de los períodos CON Fecha Liquidación. Espejo de Total pagado. */
  totalLiquidado: number = 0
  /** Σ importe liquidado al propietario Y ya cobrado al inquilino. El circuito cerrado. */
  liquidadoYCobrado: number = 0
  /** Σ importe de TODOS los períodos filtrados, hayan vencido o no. Cierra la liquidación. */
  totalPeriodos: number = 0
  //#endregion

  get f() { return this.form.controls; }
  checkedFiltroAvanzado: boolean = false;
  lstEstadosContrato: BaseDto[] = [];
  propietariosSeleccionados: PersonaPropietarioDto[] = [];

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  constructor(
    public dialog: MatDialog,
    private periodosContratoService: PeriodosContratoService,
    private snackBar: SnackBarService,
    private tipoAjusteContratoService: TipoAjusteContratoService,
    private estadosContratoService: EstadosContratoService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private datepipe: DatePipe,
  ) {
    this.form = this.formBuilder.group({
      TiposAjusteContrato: [[]],
      EstadosContrato: [[]],
      FechaAjusteDesde: [],
      FechaAjusteHasta: [],
      FechaVencimientoDesde: [],
      FechaVencimientoHasta: [],
      FechaLiquidacionDesde: [],
      FechaLiquidacionHasta: [],
      FechaPagoDesde: [],
      FechaPagoHasta: [],
      PeriodoMesDesde: [],
      PeriodoAnioDesde: [],
      PeriodoMesHasta: [],
      PeriodoAnioHasta: [],
      EsContratoActivo: [null],
    })

    breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ['contrato', 'periodo', 'accion'] :
        ['contrato', 'periodo', 'fechaVencimiento', 'fechaAjuste', 'valorAjuste', 'indiceAjusteContrato', 'importeAlquiler', 'fechaPago', 'fechaLiquidacion', 'accion']
    });
  }

  filtrosAvanzados(event: any) {
    this.checkedFiltroAvanzado = event.checked;
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }

    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const contratoDescripcion = (data.contrato?.descripcion ?? '').toString().toLowerCase();
      const periodo = `${data.periodoMes}-${data.periodoAnio}/${data.periodo}`.toLowerCase();
      const fechaVencimiento = (data.fechaVencimiento ?? '').toString().toLowerCase();
      const fechaAjuste = (data.fechaAjuste ?? '').toString().toLowerCase();
      const fechaPago = (data.fechaPago ?? '').toString().toLowerCase();
      const fechaLiquidacion = (data.fechaLiquidacion ?? '').toString().toLowerCase();
      const importeAlquiler = (data.importeAlquiler ?? '').toString().toLowerCase();

      const contenido = [
        contratoDescripcion,
        periodo,
        fechaVencimiento,
        fechaAjuste,
        fechaPago,
        fechaLiquidacion,
        importeAlquiler
      ].join(' ');

      return contenido.includes(filter);
    };
  }

  ngOnInit() {
    this.getAllTipoAjusteContrato();
    this.getAllEstadosContrato();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  // #region Persistencia de Filtros

  private saveFilterState(): void {
    try {
      const filterState: PeriodoContratoFilterState = {
        tiposAjusteContrato: this.form.controls["TiposAjusteContrato"].value,
        fechaAjusteDesde: this.form.controls["FechaAjusteDesde"].value,
        fechaAjusteHasta: this.form.controls["FechaAjusteHasta"].value,
        fechaVencimientoDesde: this.form.controls["FechaVencimientoDesde"].value,
        fechaVencimientoHasta: this.form.controls["FechaVencimientoHasta"].value,
        fechaLiquidacionDesde: this.form.controls["FechaLiquidacionDesde"].value,
        fechaLiquidacionHasta: this.form.controls["FechaLiquidacionHasta"].value,
        fechaPagoDesde: this.form.controls["FechaPagoDesde"].value,
        fechaPagoHasta: this.form.controls["FechaPagoHasta"].value,
        periodoMesDesde: this.form.controls["PeriodoMesDesde"].value,
        periodoAnioDesde: this.form.controls["PeriodoAnioDesde"].value,
        periodoMesHasta: this.form.controls["PeriodoMesHasta"].value,
        periodoAnioHasta: this.form.controls["PeriodoAnioHasta"].value,
        esContratoActivo: this.form.controls["EsContratoActivo"].value,
        contratoDetailDto: this.contratoDetailDto,
        rangoFechaAjuste: this.rangoFechaAjuste,
        rangoFechaVencimiento: this.rangoFechaVencimiento,
        rangoFechaLiquidacion: this.rangoFechaLiquidacion,
        rangoFechaPago: this.rangoFechaPago,
        estadosContrato: this.form.controls["EstadosContrato"].value,
        propietariosSeleccionados: this.propietariosSeleccionados,
      };

      sessionStorage.setItem(this.FILTER_STORAGE_KEY, JSON.stringify(filterState));
    } catch (error) {
      console.warn('Error al guardar filtro en sessionStorage:', error);
    }
  }

  private loadFilterState(): PeriodoContratoFilterState | null {
    try {
      const savedFilter = sessionStorage.getItem(this.FILTER_STORAGE_KEY);
      return savedFilter ? JSON.parse(savedFilter) : null;
    } catch (error) {
      console.warn('Error al cargar filtro desde sessionStorage:', error);
      return null;
    }
  }

  private restoreFilterState(filterState: PeriodoContratoFilterState): void {
    if (!filterState) return;

    this.form.patchValue({
      TiposAjusteContrato: filterState.tiposAjusteContrato || [],
      FechaAjusteDesde: filterState.fechaAjusteDesde ? new Date(filterState.fechaAjusteDesde) : null,
      FechaAjusteHasta: filterState.fechaAjusteHasta ? new Date(filterState.fechaAjusteHasta) : null,
      FechaVencimientoDesde: filterState.fechaVencimientoDesde ? new Date(filterState.fechaVencimientoDesde) : null,
      FechaVencimientoHasta: filterState.fechaVencimientoHasta ? new Date(filterState.fechaVencimientoHasta) : null,
      FechaLiquidacionDesde: filterState.fechaLiquidacionDesde ? new Date(filterState.fechaLiquidacionDesde) : null,
      FechaLiquidacionHasta: filterState.fechaLiquidacionHasta ? new Date(filterState.fechaLiquidacionHasta) : null,
      FechaPagoDesde: filterState.fechaPagoDesde ? new Date(filterState.fechaPagoDesde) : null,
      FechaPagoHasta: filterState.fechaPagoHasta ? new Date(filterState.fechaPagoHasta) : null,
      PeriodoMesDesde: filterState.periodoMesDesde || null,
      PeriodoAnioDesde: filterState.periodoAnioDesde || null,
      PeriodoMesHasta: filterState.periodoMesHasta || null,
      PeriodoAnioHasta: filterState.periodoAnioHasta || null,
      EsContratoActivo: filterState.esContratoActivo !== undefined ? filterState.esContratoActivo : null,
      EstadosContrato: filterState.estadosContrato || [],
    });

    if (filterState.contratoDetailDto) {
      this.contratoDetailDto = filterState.contratoDetailDto;
    }

    this.propietariosSeleccionados = filterState.propietariosSeleccionados || [];
    this.rangoFechaAjuste = filterState.rangoFechaAjuste || RangoFechasValores.Hoy;
    this.rangoFechaVencimiento = filterState.rangoFechaVencimiento || RangoFechasValores.Hoy;
    this.rangoFechaLiquidacion = filterState.rangoFechaLiquidacion || RangoFechasValores.Hoy;
    this.rangoFechaPago = filterState.rangoFechaPago || RangoFechasValores.Hoy;
  }

  private clearStoredFilter(): void {
    try {
      sessionStorage.removeItem(this.FILTER_STORAGE_KEY);
    } catch (error) {
      console.warn('Error al limpiar filtro en sessionStorage:', error);
    }
  }

  private hasActiveFilters(filterState: PeriodoContratoFilterState): boolean {
    return !!(
      filterState.contratoDetailDto ||
      (filterState.tiposAjusteContrato && filterState.tiposAjusteContrato.length > 0) ||
      filterState.fechaAjusteDesde ||
      filterState.fechaVencimientoDesde ||
      filterState.fechaLiquidacionDesde ||
      filterState.fechaPagoDesde ||
      filterState.periodoMesDesde ||
      filterState.periodoAnioDesde ||
      filterState.periodoMesHasta ||
      filterState.periodoAnioHasta ||
      (filterState.estadosContrato && filterState.estadosContrato.length > 0) ||
      (filterState.propietariosSeleccionados && filterState.propietariosSeleccionados.length > 0)
    );
  }

  // #endregion

  getAllByFilter(periodoContratoFilter: PeriodoContratoFilter) {
    this.spinner.show()
    this.periodosContratoService.getPeriodosContratoByFilterListado(periodoContratoFilter)
      .subscribe(
        data => {
          this.spinner.hide()
          this.lstPeriodosContrato = data

          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
          this.calcularTotalesCobranza()
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        }
      )
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.form.controls["Periodo"].value;
    ctrlValue.year(normalizedYear.year());
    this.form.controls["Periodo"].setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.form.controls["Periodo"].value;
    ctrlValue.month(normalizedMonth.month());
    this.form.controls["Periodo"].setValue(ctrlValue);
    datepicker?.close();
  }

  applyFilter(event: any) {
    if (event && event.target && event.target.value !== undefined) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();

      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }

  selectRangoFechaAjuste(event: any) {
    this.rangoFechaAjuste = event.value
    if (this.rangoFechaAjuste == RangoFechasValores.Todos) {
      this.form.controls["FechaAjusteDesde"].setValue(new Date((new Date().getTime() - this.rangoFechaAjuste)))
      this.form.controls["FechaAjusteHasta"].setValue(new Date((new Date().getTime() + this.rangoFechaAjuste)))
    }
    else {
      this.form.controls["FechaAjusteDesde"].setValue(new Date((new Date().getTime() - this.rangoFechaAjuste)))
      this.form.controls["FechaAjusteHasta"].setValue(new Date((new Date().getTime())))
    }
  }

  selectRangoFechaVencimiento(event: any) {
    this.rangoFechaVencimiento = event.value
    if (this.rangoFechaAjuste == RangoFechasValores.Todos) {
      this.form.controls["FechaVencimientoDesde"].setValue(new Date((new Date().getTime() - this.rangoFechaVencimiento)))
      this.form.controls["FechaVencimientoHasta"].setValue(new Date((new Date().getTime() + this.rangoFechaVencimiento)))
    }
    else {
      this.form.controls["FechaVencimientoDesde"].setValue(new Date((new Date().getTime() - this.rangoFechaVencimiento)))
      this.form.controls["FechaVencimientoHasta"].setValue(new Date((new Date().getTime())))
    }
  }

  selectRangoFechaLiquidacion(event: any) {
    this.rangoFechaLiquidacion = event.value
    if (this.rangoFechaAjuste == RangoFechasValores.Todos) {
      this.form.controls["FechaLiquidacionDesde"].setValue(new Date((new Date().getTime() - this.rangoFechaLiquidacion)))
      this.form.controls["FechaLiquidacionHasta"].setValue(new Date((new Date().getTime() + this.rangoFechaLiquidacion)))
    }
    else {
      this.form.controls["FechaLiquidacionDesde"].setValue(new Date((new Date().getTime() - this.rangoFechaLiquidacion)))
      this.form.controls["FechaLiquidacionHasta"].setValue(new Date((new Date().getTime())))
    }
  }

  selectRangoFechaPago(event: any) {
    this.rangoFechaPago = event.value
    if (this.rangoFechaPago == RangoFechasValores.Todos) {
      this.form.controls["FechaPagoDesde"].setValue(new Date((new Date().getTime() - this.rangoFechaPago)))
      this.form.controls["FechaPagoHasta"].setValue(new Date((new Date().getTime() + this.rangoFechaPago)))
    }
    else {
      this.form.controls["FechaPagoDesde"].setValue(new Date((new Date().getTime() - this.rangoFechaPago)))
      this.form.controls["FechaPagoHasta"].setValue(new Date((new Date().getTime())))
    }
  }

  /**
   * TOTALES ORIGINALES. Este método es el que existía y no cambió de resultado.
   *
   *   Devengado          -> ya venció (Fecha Vencimiento <= hoy), se haya cobrado o no
   *   Pagado             -> tiene Fecha Pago
   *   A cobrar           -> sin Fecha Pago, incluidos los que todavía no vencieron
   *   Deuda Inquilino    -> sin Fecha Pago Y ya vencido  == la mora real
   *   Liquidado s/cobrar -> ya se le liquidó al propietario pero el inquilino no pagó
   *   Por liquidar       -> sin Fecha Liquidación
   *
   * Al final llama a los dos métodos con los agregados posteriores. Están
   * separados a propósito: así se ve de un vistazo qué números son los de
   * siempre y cuáles se sumaron después, y se puede tocar uno sin leer el otro.
   *
   * Ojo con qué cierra contra qué: el devengado es sólo lo vencido, mientras que
   * los totales de liquidación se miden sobre todos los períodos del filtro.
   */
  calcularTotalesCobranza() {
    this.totalDevengado = 0
    this.totalPagado = 0
    this.totalACobrar = 0
    this.deudaInquilino = 0
    this.liquidadoSinCobrar = 0
    this.totalPorLiquidar = 0
    this.devengadoSinCobrarNiLiquidar = 0
    this.hayLiquidacionReal = false
    this.hayLiquidacionFicticia = false
    this.cantidadPeriodosEnMora = 0

    const hoy = new Date()
    hoy.setHours(23, 59, 59, 999)

    this.dataSource.data.forEach(periodo => {
      const importe = periodo.importeAlquiler ?? 0

      const tienePago = this.tieneFecha(periodo.fechaPago)
      const tieneLiquidacion = this.tieneFecha(periodo.fechaLiquidacion)
      const venci = this.aFecha(periodo.fechaVencimiento)
      const estaVencido = venci != null && venci <= hoy

      if (estaVencido)
        this.totalDevengado += importe

      if (tienePago)
        this.totalPagado += importe
      else {
        this.totalACobrar += importe

        if (estaVencido) {
          this.deudaInquilino += importe
          this.cantidadPeriodosEnMora++
        }

        if (tieneLiquidacion)
          this.liquidadoSinCobrar += importe
      }

      const esFicticia = periodo.idTipoLiquidacion === TiposLiquidacion.Ficticia

      if (esFicticia)
        this.hayLiquidacionFicticia = true
      else
        this.hayLiquidacionReal = true

      if (!tieneLiquidacion) {
        if (esFicticia) {
          // Ficticia: se le rinde al propietario aunque el inquilino no pague.
          // Lo único que se pide es que el período se haya devengado.
          if (estaVencido)
            this.totalPorLiquidar += importe
        }
        else {
          // Real: sólo lo cobrado. Lo vencido e impago queda a la espera.
          if (tienePago)
            this.totalPorLiquidar += importe
          else if (estaVencido)
            this.devengadoSinCobrarNiLiquidar += importe
        }
      }
    })

    // El agregado posterior vive aparte, en su propio método
    this.calcularTotalesLiquidacion()
  }

  /**
   * AGREGADO POSTERIOR — cierre de la liquidación al propietario.
   *
   * No modifica ninguno de los totales de calcularTotalesCobranza: sólo agrega
   * los que faltaban para que la tarjeta del propietario cierre sola.
   *
   *   Total liquidado + Total por liquidar = Total períodos
   *
   * "Liquidado y cobrado" es la contraparte de "Liquidado sin cobrar", que ya
   * se calculaba arriba. Los dos abren el Total liquidado.
   */
  private calcularTotalesLiquidacion() {
    this.totalPeriodos = 0
    this.totalLiquidado = 0
    this.liquidadoYCobrado = 0

    this.dataSource.data.forEach(periodo => {
      const importe = periodo.importeAlquiler ?? 0
      const tienePago = this.tieneFecha(periodo.fechaPago)
      const tieneLiquidacion = this.tieneFecha(periodo.fechaLiquidacion)

      this.totalPeriodos += importe

      if (!tieneLiquidacion)
        return

      this.totalLiquidado += importe

      if (tienePago)
        this.liquidadoYCobrado += importe
    })
  }

  /**
   * Glosario de los totales.
   *
   * Los números se parecen entre sí y no son intercambiables: sin la explicación
   * es fácil restar dos y sacar una conclusión equivocada.
   */
  abrirAyudaTotales(seccion: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = "60%";
    dialogConfig.data = { seccion: seccion };

    this.dialog.open(DialogAyudaTotalesComponent, dialogConfig);
  }

  /** Las fechas vacías llegan como null, "" o 01/01/0001 según el origen */
  private tieneFecha(fecha: any): boolean {
    return this.aFecha(fecha) != null
  }

  private aFecha(fecha: any): Date | null {
    if (!fecha)
      return null

    if (fecha === '01/01/0001' || String(fecha).startsWith('0001-01-01'))
      return null

    const parsed = new Date(fecha)

    return isNaN(parsed.getTime()) ? null : parsed
  }

  getTotalAlquiler(): number {
    let valor = 0
    valor = this.lstPeriodosContrato.map(t => t.importeAlquiler).reduce((acc, value) => acc + value, 0) as number;
    return valor
  }

  openDialog(periodoContratoDetail: PeriodoContratoDetailDto) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = periodoContratoDetail,
      dialogConfig.width = "50%"

    const dialogRef = this.dialog.open(DialogVerPeriodoContratoDetailDtoComponent, dialogConfig);
  }

  openDialogEditar(periodoContratoDetail: PeriodoContratoDetailDto) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = periodoContratoDetail
    dialogConfig.width = "60%"

    const dialogRef = this.dialog.open(DialogUpdatePeriodoContratoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.saveFilterState();
        this.filtrar();
      }
    });
  }

  selectContrato(baseDto: BaseDto | null) {
    if (!isFalsy(baseDto))
      this.contratoDetailDto = baseDto
  }

  filtrar() {
    let periodoContratoFilter = new PeriodoContratoFilter

    let fechaAjusteDesde = this.datepipe.transform(this.form.controls["FechaAjusteDesde"].value, 'yyyy-MM-dd') as string;
    let fechaAjusteHasta = this.datepipe.transform(this.form.controls["FechaAjusteHasta"].value, 'yyyy-MM-dd') as string;
    if (fechaAjusteDesde) {
      fechaAjusteDesde = fechaAjusteDesde + ' 00:00:00';
      fechaAjusteHasta = fechaAjusteHasta + ' 23:59:59';
    }

    let fechaVencimientoDesde = this.datepipe.transform(this.form.controls["FechaVencimientoDesde"].value, 'yyyy-MM-dd') as string;
    let fechaVencimientoHasta = this.datepipe.transform(this.form.controls["FechaVencimientoHasta"].value, 'yyyy-MM-dd') as string;
    if (fechaVencimientoDesde) {
      fechaVencimientoDesde = fechaVencimientoDesde + ' 00:00:00';
      fechaVencimientoHasta = fechaVencimientoHasta + ' 23:59:59';
    }

    let fechaLiquidacionDesde = this.datepipe.transform(this.form.controls["FechaLiquidacionDesde"].value, 'yyyy-MM-dd') as string;
    let fechaLiquidacionHasta = this.datepipe.transform(this.form.controls["FechaLiquidacionHasta"].value, 'yyyy-MM-dd') as string;
    if (fechaLiquidacionDesde) {
      fechaLiquidacionDesde = fechaLiquidacionDesde + ' 00:00:00';
      fechaLiquidacionHasta = fechaLiquidacionHasta + ' 23:59:59';
    }

    let fechaPagoDesde = this.datepipe.transform(this.form.controls["FechaPagoDesde"].value, 'yyyy-MM-dd') as string;
    let fechaPagoHasta = this.datepipe.transform(this.form.controls["FechaPagoHasta"].value, 'yyyy-MM-dd') as string;
    if (fechaPagoDesde) {
      fechaPagoDesde = fechaPagoDesde + ' 00:00:00';
      fechaPagoHasta = fechaPagoHasta + ' 23:59:59';
    }

    periodoContratoFilter.esContratoActivo = this.form.controls["EsContratoActivo"].value
    periodoContratoFilter.periodoMesDesde = this.form.controls["PeriodoMesDesde"].value
    periodoContratoFilter.periodoAnioDesde = this.form.controls["PeriodoAnioDesde"].value
    periodoContratoFilter.periodoMesHasta = this.form.controls["PeriodoMesHasta"].value
    periodoContratoFilter.periodoAnioHasta = this.form.controls["PeriodoAnioHasta"].value
    let idsTipoAjusteContrato = this.form.controls["TiposAjusteContrato"].value
    periodoContratoFilter.idsEstadoContrato = this.form.controls["EstadosContrato"].value;
    periodoContratoFilter.idsPropietario = this.propietariosSeleccionados.map(p => p.id_Propietario);
    periodoContratoFilter.fechaAjusteDesde = fechaAjusteDesde
    periodoContratoFilter.fechaAjusteHasta = fechaAjusteHasta
    periodoContratoFilter.idsTipoAjusteContrato = idsTipoAjusteContrato
    periodoContratoFilter.fechaVencimientoDesde = fechaVencimientoDesde
    periodoContratoFilter.fechaVencimientoHasta = fechaVencimientoHasta
    periodoContratoFilter.fechaLiquidacionDesde = fechaLiquidacionDesde
    periodoContratoFilter.fechaLiquidacionHasta = fechaLiquidacionHasta
    periodoContratoFilter.fechaPagoDesde = fechaPagoDesde
    periodoContratoFilter.fechaPagoHasta = fechaPagoHasta

    if (this.contratoDetailDto)
      periodoContratoFilter.idContrato = this.contratoDetailDto.id

    this.saveFilterState();

    this.spinner.show()
    this.periodosContratoService.getPeriodosContratoByFilterListado(periodoContratoFilter)
      .subscribe(
        data => {
          this.spinner.hide();
          this.lstPeriodosContrato = data
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
          this.calcularTotalesCobranza()
        },
        error => {
          this.spinner.hide();
          this.snackBar.showError(error, "Error");
        }
      )
  }

  clearDateControls() {
    this.form.patchValue({
      TiposAjusteContrato: [],
      EstadosContrato: [],
      FechaAjusteDesde: null,
      FechaAjusteHasta: null,
      FechaVencimientoDesde: null,
      FechaVencimientoHasta: null,
      FechaLiquidacionDesde: null,
      FechaLiquidacionHasta: null,
      FechaPagoDesde: null,
      FechaPagoHasta: null,
      PeriodoMesDesde: null,
      PeriodoAnioDesde: null,
      PeriodoMesHasta: null,
      PeriodoAnioHasta: null,
      EsContratoActivo: null
    });


    if (this.buscarPropietarioRef) {
      this.buscarPropietarioRef.entityControl.setValue('');
      this.buscarPropietarioRef.entitySelect = null;
    }

    this.propietariosSeleccionados = [];
    this.contratoDetailDto = null;

    this.rangoFechaAjuste = RangoFechasValores.Hoy;
    this.rangoFechaVencimiento = RangoFechasValores.Hoy;
    this.rangoFechaLiquidacion = RangoFechasValores.Hoy;
    this.rangoFechaPago = RangoFechasValores.Hoy;

    this.clearStoredFilter();

    this.dataSource.data = [];
    this.data = false;
    this.lstPeriodosContrato = [];
    this.calcularTotalesCobranza();
  }

  getAllEstadosContrato() {
    this.spinner.show("spBusquedaEstadosContrato");
    this.estadosContratoService.getAll().subscribe(
      data => {
        this.spinner.hide("spBusquedaEstadosContrato");
        this.lstEstadosContrato = data.sort((a, b) => a.descripcion.toString().localeCompare(b.descripcion.toString()));
      },
      error => {
        this.spinner.hide("spBusquedaEstadosContrato");
        this.snackBar.showError(error, "Error");
      }
    );
  }

  selectPropietario(propietario: PersonaPropietarioDto | null) {
    if (!isFalsy(propietario) && !this.propietariosSeleccionados.some(p => p.id_Propietario === propietario!.id_Propietario)) {
      this.propietariosSeleccionados.push(propietario!);
    }
  }

  removePropietario(propietario: PersonaPropietarioDto) {
    this.propietariosSeleccionados = this.propietariosSeleccionados.filter(p => p.id_Propietario !== propietario.id_Propietario);
  }

  getAllTipoAjusteContrato() {
    this.spinner.show("spBusquedaTipoAjusteContrato")
    this.tipoAjusteContratoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaTipoAjusteContrato")
          this.lstTiposAjusteContrato = data.sort((a, b) => a.descripcion.toString().localeCompare(b.descripcion.toString()))

          const savedFilter = this.loadFilterState();

          if (savedFilter) {
            this.restoreFilterState(savedFilter);

            if (this.hasActiveFilters(savedFilter)) {
              setTimeout(() => this.filtrar(), 100);
            }
          } else {
            const idsSeleccionados = this.lstTiposAjusteContrato.map(tipo => tipo.id);
            this.form.get('TiposAjusteContrato')?.setValue(idsSeleccionados);
          }
        },
        error => {
          this.spinner.hide("spBusquedaTipoAjusteContrato")
          this.snackBar.showError(error, "Error");
        }
      )
  }

  isVencidoSinPago(element: any): boolean {
    const hoy = new Date();
    const fechaVencimiento = new Date(element.fechaVencimiento);
    const fechaPago = element.fechaPago ? new Date(element.fechaPago) : null;

    return fechaVencimiento < hoy && !fechaPago;
  }

  //#region Helper

  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }
  //#endregion
}
